import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SeoService } from '../../seo.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'app-custom-barchart',
  templateUrl: './custom-barchart.component.html',
  styleUrls: ['./custom-barchart.component.css'],
})
export class CustomBarchartComponent implements OnInit {
  constructor(
    private seoService: SeoService,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
  @Input() barchartInputData: any;
  @Output() barchartClicked: any = new EventEmitter();
  @Output() competitorUrlChanged: any = new EventEmitter();
  @Output() factorChange: any = new EventEmitter();
  @Input() cardData: any;
  @Input() cardName: any;
  @Input() keywordData: any;
  @Input() selectedCard: any;
  @Input() isFreemiumUser: boolean;
  @Input() isViewAllActiveProject: boolean;
  @Output() constructFixes: any = new EventEmitter();

  @Input() fromSharablePage: boolean;
  @Output() viewMoreClicked: any = new EventEmitter();

  showV2Design: boolean = false;

  comparableChart: boolean;

  barchartData: any = [];
  loadingChart: boolean = true;
  selectProjectInsight: any = [];
  competitorInsight: any = [];
  viewClientURL: string = '';
  clientURL: string = '';
  competitorURL: string = '';

  competitors: any = [];
  selectedCompetitorDomain: any = [];
  descriptions: any = {};

  allCompetitorsData: any = [];

  selectedFactor: any;

  rankings: any = [];
  units: any = {};

  clientPosition: number = 0;
  competitorPosition: number = 0;

  descriptionChart: any = [];
  data_descriptionChart: any = {};
  descriptionChart_m_position: number = 0;
  comp_combined_values: any = {};
  overview_filter_active: boolean = false;
  renamed_variables: any;
  rename_variables_positive: any;

  correct_values: any = {};
  meter_object: any = {};
  showMeterChart: boolean = true;

  your_icon_src: string;
  competitor_icon_src: string;

  activeFilter: any = '';
  selectedCompetitor: any = '';

  rankingImpactDirection: any = '-1';

  domainSelected: any = {};

  seoSubscription: any;

  selectedValueSub: Subscription;

  blurredElements: number = 6;
  ngOnInit() {
    this.selectedValueSub = this.seoService.selectedValue$.subscribe(
      (object) => {
        if (object != null) {
          this.domainSelected = object;
        } else {
          this.domainSelected['domain'] = 'Competitor';
        }

        this.selectProjectInsight = this.filterInsightDomain(
          this.barchartInputData.domain,
          this.factorName
        );
        if (this.selectedcompetitor) {
          this.competitorInsight = this.filterInsightDomain(
            this.domainSelected.domain,
            this.factorName
          );
        } else {
          this.competitorInsight = {
            impact: 0,
            range: '0 - 10',
            value: 0,
          };
        }

        if (
          this.selectProjectInsight?.['range'] != '' &&
          this.competitorInsight?.['range'] == ''
        ) {
          this.selectProjectInsight = this.filterInsightDomain(
            this.barchartInputData.domain,
            this.factorName,
            true
          );
          this.competitorInsight = this.filterInsightDomain(
            this.domainSelected.domain,
            this.factorName,
            true
          );
        }
      }
    );
  }

  test: any;

  show_optimal_value: boolean = true;
  filterInsightDomain(domain: any, variable: any, byPass1020: boolean = false) {
    try {
      let tmpVariable = this.keywordData['variables_scores_mean'].find(
        (obj: any) => obj.domain == domain
      )[variable];

      this.show_optimal_value = true;
      if (tmpVariable['range'] == '10% - 20%' || tmpVariable['range'] == '') {
        this.show_optimal_value = false;
        tmpVariable['range'] = '';
      }
      if (byPass1020) {
        this.show_optimal_value = true;
      }

      return tmpVariable;
    } catch (e) {
      return null;
    }
  }

  ngOnChanges() {
    this.loadingChart = true;
    if (!this.barchartInputData) {
      this.loadingChart = false;
      return;
    }

    this.seoSubscription = this.localStorageService.get('seoSubscription');

    this.clientURL = this.barchartInputData['url']?.client;
    this.viewClientURL = this.barchartInputData['url']?.client;

    this.activeFilter = this.barchartInputData.activeFilter;

    if (this.viewClientURL == '/') {
      this.viewClientURL = JSON.parse(
        sessionStorage.getItem('selectedProject') || '{}'
      )?.domain;
    }

    this.renamed_variables = this.barchartInputData.renamed_variables;
    this.rename_variables_positive =
      this.barchartInputData.rename_variables_positive;

    // this.competitorURL = this.barchartInputData['url']?.competitor;
    // this.comparableChart = this.barchartInputData['comparable'];
    // this.competitors = this.barchartInputData['competitors'];
    // this.descriptions = this.barchartInputData['descriptions'];
    // this.allCompetitorsData = this.barchartInputData['allCompetitors'];
    // this.rankings = this.barchartInputData['rankings'];
    // this.units = this.barchartInputData['units'];
    // this.data_descriptionChart = this.barchartInputData['chartsData'];
    // this.comp_combined_values =
    //   this.barchartInputData?.['comp_combined_values'];
    this.correct_values = this.barchartInputData?.['correct_values'];

    this.constructBarchartData();
  }
  constructCompetitorsData() {
    let tmpArr = [];

    for (let i = 0; i < this.competitors.length; i++) {
      for (let j = 0; j < this.rankings.length; j++) {
        if (this.rankings[j].url === this.competitors[i]) {
          tmpArr.push({
            url: this.competitors[i],
            rank: this.rankings[j].rank,
          });
        }
      }
    }
    this.competitors = tmpArr;
  }
  // to be removed - add dummy values from -100 to 100
  addRandomValues(arr: any) {
    const randomValues = () => {
      return Math.floor(Math.random() * 200) - 100;
    };
    // to be removed - add dummy values from -100 to 100 - start
    for (let i = 0; i < arr.length; i++) {
      arr[i].value = randomValues();
    }
  }

  sendFactorData(data: any) {
    // this.factorChange.emit(data);
  }

  formatValue(value: number) {
    if (value === 0) {
      return value.toFixed(0);
    } else if (Math.abs(value) >= 10) {
      return value.toFixed(0);
    } else if (Math.abs(value) < 1) {
      return value.toFixed(2);
    } else if (value % 1 !== 0) {
      return value.toFixed(2);
    } else {
      return value.toFixed(0);
    }
  }

  constructBarchartData() {
    try {
      if (this.barchartInputData) {
        if (this.activeFilter == "All KPI's") {
          let chartDataLength = this.barchartInputData?.chartData?.length || 0;
          let list = [];
          for (let i = 0; i < this.barchartInputData.chartData?.length; i++) {
            for (
              let j = 0;
              j < this.barchartInputData.chartData[i].variables?.length;
              j++
            ) {
              if (this.barchartInputData.chartData[i].variable != 'Technical') {
                list.push(this.barchartInputData.chartData[i].variables[j]);
              } else {
                if (
                  this.barchartInputData.chartData[i].variables[j].name ==
                  'performance_score'
                ) {
                  list.push(this.barchartInputData.chartData[i].variables[j]);
                } else if (
                  this.barchartInputData.chartData[i].variables[j].name ==
                  'speedIndex'
                ) {
                  list.push(this.barchartInputData.chartData[i].variables[j]);
                } else if (
                  this.barchartInputData.chartData[i].variables[j].name ==
                  'totalByteWeight'
                ) {
                  list.push(this.barchartInputData.chartData[i].variables[j]);
                } else if (
                  this.barchartInputData.chartData[i].variables[j].name ==
                  'accessibility_score'
                ) {
                  list.push(this.barchartInputData.chartData[i].variables[j]);
                } else if (
                  this.barchartInputData.chartData[i].variables[j].name ==
                  'best_practices_score'
                ) {
                  list.push(this.barchartInputData.chartData[i].variables[j]);
                } else if (
                  this.barchartInputData.chartData[i].variables[j].name ==
                  'Time to Interactive'
                ) {
                  list.push(this.barchartInputData.chartData[i].variables[j]);
                } else if (
                  this.barchartInputData.chartData[i].variables[j].name ==
                  'Largest Contentful Paint'
                ) {
                  list.push(this.barchartInputData.chartData[i].variables[j]);
                }
              }
            }
          }

          this.barchartData = list;
        } else if (this.activeFilter == 'Backlink Profile') {
          this.barchartData = this.barchartInputData.chartData.filter(
            (o: any) => o.variable === 'Backlink Profile'
          )[0].variables;
        } else if (this.activeFilter == 'Backlink Relevance') {
          this.barchartData = this.barchartInputData.chartData.filter(
            (o: any) => o.variable === 'Backlink Relevance'
          )[0].variables;
        } else if (this.activeFilter == 'Content Relevance') {
          this.barchartData = this.barchartInputData.chartData.filter(
            (o: any) => o.variable === 'Content Relevance'
          )[0].variables;
        } else if (this.activeFilter == 'Internal Linking') {
          this.barchartData = this.barchartInputData.chartData.filter(
            (o: any) => o.variable === 'Internal Linking'
          )[0].variables;
        } else if (this.activeFilter == 'Technical') {
          this.barchartData = this.barchartInputData.chartData.filter(
            (o: any) => o.variable === 'Technical'
          )[0].variables;
          this.showMeterChart = true;
        }

        if (this.rankingImpactDirection == '1') {
          this.barchartData = this.barchartData.sort((a: any, b: any) => {
            if (a['blurElement']) {
              return -1;
            } else if (b['blurElement']) {
              return 1;
            }
            return b.value - a.value;
          });
        } else {
          this.barchartData = this.barchartData.sort((a: any, b: any) => {
            if (a['blurElement']) {
              return -1;
            } else if (b['blurElement']) {
              return 1;
            }
            return a.value - b.value;
          });
        }

        if (
          this.barchartInputData['cardChangedSort'] &&
          this.seoSubscription == 'Freemium'
        ) {
          this.barchartData = this.barchartData.sort((a: any, b: any) => {
            if (a['blurElement']) {
              return -1;
            } else if (b['blurElement']) {
              return 1;
            }
            return a.value - b.value;
          });
        }

        const allowedGroups = ["All KPI's", 'Content Relevance'];

        if (
          this.isFreemiumUser &&
          this.barchartInputData?.top_selected &&
          allowedGroups.includes(this.selectedCard)
        ) {
          this.barchartData = this.barchartData.filter((data: any) => {
            return this.barchartInputData?.top_selected.includes(data.name);
          });
        }
      }

      this.loadingChart = false;

      // if (this.seoSubscription === 'Freemium') {
      //   let blurElementMaxLength =
      //     this.barchartData?.length > this.blurredElements
      //       ? this.blurredElements
      //       : Math.ceil(this.barchartData?.length / 2);

      //   for (let i = 0; i < this.barchartData.length; i++) {
      //     if (i < blurElementMaxLength) {
      //       this.barchartData[i]['blurElement'] = true;
      //     } else {
      //       break;
      //     }
      //   }

      //   this.onChartClick(this.barchartData[blurElementMaxLength]);
      // } else {
      //   this.onChartClick(this.barchartData[0]);
      // }

      try {
        if (this.activeFilter == "All KPI's") {
          const filteredData = this.barchartData.filter((data: any) => {
            return data.value < 0;
            // return (
            //   ['Content Relevance', 'Backlink Relevance'].includes(
            //     data.tmp_category
            //   ) && data.value < 0
            // );
          });

          filteredData.forEach((data: any) => {
            data['name_formatted'] =
              this.renamed_variables?.[this.removeCommas(data?.name)]?.name;
            data['description_formatted'] =
              this.renamed_variables?.[this.removeCommas(data?.name)]
                ?.description || data?.description;
            data['keywords_formatted'] = this.formatNumberWithCommas(
              this.barchartInputData?.variable_labels?.[data.name]
            );
            data['value_formatted'] = this.formatValue(data.value);
          });

          queueMicrotask(() => this.constructFixes.emit(filteredData));
        }
      } catch (e) {
        console.log(e);
      }

      this.onChartClick(this.barchartData[0]);
    } catch (e) {
      console.log(e);
      this.loadingChart = false;
    }
  }
  constructComparableBarchartData() {
    try {
      const returnPercentage = (value: any, maxValue: any) => {
        if (value === 0) return 0;
        let percentage = Math.abs(parseFloat(value));
        let prc = (percentage / maxValue) * 100;
        if (prc > 100) return 100;
        if (prc < 0) return 0;
        return prc.toFixed(2);
      };
      const returnNumber = (number: any) => {
        if (isNaN(number)) return '0.000';

        if (Math.abs(number) > maxValue) {
          maxValue = Math.abs(number);
        }

        return number.toFixed(1);
      };

      this.barchartData = [];

      let selectedProject = JSON.parse(
        sessionStorage.getItem('selectedProject') || ''
      );
      let clientObject = this.allCompetitorsData?.find(
        (x: any) =>
          x.url_analyse.includes(this.clientURL) &&
          x.url_analyse.includes(selectedProject['domain'])
      );

      let maxValue = 0;

      let clientObjectRanking = this.rankings?.find(
        (x: any) => x.domain === selectedProject['domain']
      );
      let competitorObjectRanking = this.rankings?.find(
        (x: any) => x.url === this.competitorURL
      );

      this.your_icon_src = clientObjectRanking?.icon;
      this.competitor_icon_src = competitorObjectRanking?.icon;

      this.clientPosition = clientObjectRanking?.rank;
      this.competitorPosition = competitorObjectRanking?.rank;

      if (
        this.barchartInputData?.['chartData']?.['clientData']?.[
          'overview_filter'
        ]
      ) {
        this.overview_filter_active = true;
        let valuesObj: any = {
          onpage: {
            viewName: 'On-Page',
            description:
              'On-Page SEO focuses on optimizing individual web pages to improve their rankings and attract more relevant traffic. This includes optimizing content with relevant keywords, using proper heading tags, creating compelling meta descriptions and title tags, improving internal linking, and ensuring high-quality, original content.',
          },
          technical: {
            viewName: 'Technical',
            description:
              'Technical SEO involves optimizing the backend structure and foundation of your website. This includes improving site speed, ensuring mobile-friendliness, enhancing security with HTTPS, creating XML sitemaps, and using structured data markup.',
          },
          backlinks: {
            viewName: 'Backlink',
            description:
              "Backlink factors involve various metrics that influence the quality and impact of backlinks on your site's SEO.",
          },
          backlink_relevancies: {
            viewName: 'Backlink Relevance',
            description:
              "Backlink relevances involve acquiring links from other websites that are relevant to your site's content and industry. High-quality, relevant backlinks signal to search engines that your site is a credible and authoritative source of information. This improves your site's trustworthiness and can significantly boost its ranking in search results.",
          },
          relevancies: {
            viewName: 'Relevances',
            description:
              "Relevancies refer to how well your website's content matches the search intent of users and the keywords they are searching for. This includes ensuring your content is highly relevant, valuable, and aligned with the interests and needs of your target audience.",
          },
        };
        let client_factors: any = {};
        let competitor_factors: any = {};

        for (let i = 0; i < this.comp_combined_values.length; i++) {
          if (
            clientObjectRanking?.['url'] ==
            this.comp_combined_values[i]['url_analyse']
          ) {
            client_factors = this.comp_combined_values[i];
          }
          if (
            competitorObjectRanking?.['url'] ==
            this.comp_combined_values[i]['url_analyse']
          ) {
            competitor_factors = this.comp_combined_values[i];
          }
        }

        let values_keys = Object.keys(valuesObj);
        for (let i = 0; i < values_keys.length; i++) {
          this.barchartData.push({
            name: values_keys[i],
            clientObject: {
              value: returnNumber(client_factors[values_keys[i]]),
              percentage: 0,
              corr_sign: client_factors[values_keys[i]] > 0 ? -1 : 1,
              variable_values: '',
              hoverText: '',
            },
            competitorObject: {
              value: returnNumber(competitor_factors[values_keys[i]]),
              percentage: 0,
              corr_sign: competitor_factors[values_keys[i]] > 0 ? -1 : 1,
              variable_values: '',
              hoverText: '',
              meter_value: competitor_factors[values_keys[i]],
            },
            showName: valuesObj[values_keys[i]]?.viewName,
            description: valuesObj[values_keys[i]]?.description,
            selected: false,
          });
        }
      } else {
        this.overview_filter_active = false;
        for (let factor in this.barchartInputData?.['chartData']?.[
          'clientData'
        ]) {
          let clientViewValues = factor.endsWith('_sim')
            ? Math.round(clientObjectRanking?.['factors']?.[factor] * 100) + '%'
            : clientObjectRanking?.['factors']?.[factor];

          let competitorViewValue = factor.endsWith('_sim')
            ? Math.round(competitorObjectRanking?.['factors']?.[factor] * 100) +
              '%'
            : competitorObjectRanking?.['factors']?.[factor];

          let tmpUnit = factor.endsWith('_sim') ? '%' : '';
          if (this.units && this.units[factor]) {
            if (this.units[factor].type === 'int') {
              clientViewValues = Math.round(parseFloat(clientViewValues));
              competitorViewValue = Math.round(parseFloat(competitorViewValue));
            }
            if (this.units[factor].unit != '') {
              clientViewValues = clientViewValues + this.units[factor].unit;
              competitorViewValue =
                competitorViewValue + this.units[factor].unit;

              tmpUnit = this.units[factor].unit;
            }
            if (this.units[factor].replace === 'Yes/No') {
              tmpUnit = 'Yes/No';

              clientViewValues = clientViewValues == '1.00' ? 'Yes' : 'No';
              competitorViewValue =
                competitorViewValue == '1.00' ? 'Yes' : 'No';
            }
          }

          this.barchartData.push({
            name: factor,
            clientObject: {
              value: returnNumber(clientObject?.[factor]),
              percentage: 0,
              corr_sign: clientObject?.[factor] < 0 ? -1 : 1,
              variable_values: clientViewValues,
              hoverText:
                'This factor ' +
                (clientObject?.[factor] < 0 ? 'increased' : 'decreased') +
                ' your position by ' +
                (returnNumber(clientObject?.[factor]).includes('-')
                  ? ''
                  : '-') +
                returnNumber(clientObject?.[factor]).replace('-', '') +
                ' positions',
            },
            competitorObject: {
              value: returnNumber(
                this.barchartInputData?.['chartData']?.['competitorData']?.[
                  factor
                ]
              ),
              percentage: 0,
              corr_sign:
                this.barchartInputData?.['chartData']?.['competitorData']?.[
                  factor
                ] < 0
                  ? -1
                  : 1,
              variable_values: competitorViewValue,
              hoverText:
                'This factor ' +
                (this.barchartInputData?.['chartData']?.['competitorData']?.[
                  factor
                ] < 0
                  ? 'increased'
                  : 'decreased') +
                " your competitor's position by " +
                (returnNumber(
                  this.barchartInputData?.['chartData']?.['competitorData']?.[
                    factor
                  ]
                ).includes('-')
                  ? ''
                  : '-') +
                returnNumber(
                  this.barchartInputData?.['chartData']?.['competitorData']?.[
                    factor
                  ]
                ).replace('-', '') +
                ' positions',
              meter_value: competitorViewValue,
              unit: tmpUnit,
            },
            showName:
              this.descriptions[
                factor?.replace(/_embedding/gi, '').replace(/_technical/gi, '')
              ]?.name,
            description:
              this.descriptions[
                factor?.replace(/_embedding/gi, '').replace(/_technical/gi, '')
              ]?.description,
            selected: false,
          });
        }
      }

      for (let i = 0; i < this.barchartData.length; i++) {
        this.barchartData[i].clientObject.percentage = returnPercentage(
          this.barchartData[i].clientObject.value,
          maxValue
        );
        this.barchartData[i].competitorObject.percentage = returnPercentage(
          this.barchartData[i].competitorObject.value,
          maxValue
        );
      }

      this.barchartData = this.barchartData.sort((a: any, b: any) => {
        let tmpA = Math.abs(parseFloat(a.clientObject.value));
        let tmpB = Math.abs(parseFloat(b.clientObject.value));

        return tmpB - tmpA;
      });
      if (
        this.data_descriptionChart &&
        this.barchartData &&
        this.barchartData[0]
      ) {
        this.contructDescriptionChart(
          this.data_descriptionChart[this.barchartData[0].name]
        );
      }

      this.onChartClick(this.barchartData[0]);

      setTimeout(() => {
        this.loadingChart = false;
      }, 300);
    } catch (e) {
      console.log(e);
      this.loadingChart = false;
    }
  }
  removeCommas(value: string) {
    if (!value || !value?.includes('`')) return value;
    return value?.replace(/`/g, '');
  }
  formatNumberWithCommas(number: any) {
    return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  contructDescriptionChart(data: any) {
    if (!data) return;

    let maxValue = 0;
    this.descriptionChart = [];
    let lastIndex = -1;

    for (let i = 0; i < data?.['v']?.length; i++) {
      let value = parseFloat(data?.['v'][i].per);
      if (Math.abs(value) > maxValue) maxValue = Math.abs(value);

      if (data?.['m'] >= data?.['v'][i].value) {
        if (data?.['m'] > data?.['v'][i]) {
          lastIndex = i - 1;
        } else if (data?.['m'] == data?.['v'][i]) {
          lastIndex = i;
        } else {
          lastIndex = i;
        }
      }

      this.descriptionChart.push({
        name: data?.['v'][i].value,
        value: value,
        percentage: 0,
        yourPosition: false,
      });
    }

    if (lastIndex !== -1) {
      this.descriptionChart[lastIndex].yourPosition = true;
    } else {
      this.descriptionChart[0].yourPosition = true;
    }

    maxValue = maxValue * 1.2;

    for (let i = 0; i < this.descriptionChart.length; i++) {
      this.descriptionChart[i].percentage = parseFloat(
        ((this.descriptionChart[i].value / maxValue) * 100).toFixed(2)
      );
    }
  }
  sortToogle: boolean = false;
  prevSortType: string = 'client';
  sortFunctionShapleyValue(valuesType: string) {
    let data = this.barchartData;
    if (this.prevSortType === valuesType) {
      this.sortToogle = !this.sortToogle;
    } else {
      this.sortToogle = false;
    }
    this.prevSortType = valuesType;
    if (valuesType === 'client') {
      if (this.sortToogle) {
        data = this.barchartData.sort((a: any, b: any) => {
          let tmpA = parseFloat(a.clientObject.value);
          let tmpB = parseFloat(b.clientObject.value);
          return tmpA - tmpB;
        });
      } else {
        data = this.barchartData.sort((a: any, b: any) => {
          let tmpA = parseFloat(a.clientObject.value);
          let tmpB = parseFloat(b.clientObject.value);
          return tmpB - tmpA;
        });
      }
    } else if (valuesType === 'competitor') {
      if (this.sortToogle) {
        data = this.barchartData.sort((a: any, b: any) => {
          let tmpA = parseFloat(a.competitorObject.value);
          let tmpB = parseFloat(b.competitorObject.value);
          return tmpA - tmpB;
        });
      } else {
        data = this.barchartData.sort((a: any, b: any) => {
          let tmpA = parseFloat(a.competitorObject.value);
          let tmpB = parseFloat(b.competitorObject.value);
          return tmpB - tmpA;
        });
      }
    }
  }

  sortFunction() {
    this.rankingImpactDirection =
      this.rankingImpactDirection == '1' ? '-1' : '1';

    if (this.rankingImpactDirection == '1') {
      this.barchartData = this.barchartData.sort((a: any, b: any) => {
        if (a['blurElement'] || b['blurElement']) {
          return 0;
        }
        return b.value - a.value;
      });
    } else {
      this.barchartData = this.barchartData.sort((a: any, b: any) => {
        if (a['blurElement'] || b['blurElement']) {
          return 0;
        }
        return a.value - b.value;
      });
    }
  }

  formatValueString(val: any) {
    if (typeof val === 'number') {
      return val
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return val;
    }
  }

  factorName: any;

  competitorUrlChangedFunc() {
    this.sortToogle = false;
    this.prevSortType = 'client';
    this.competitorUrlChanged.emit(this.competitorURL);
    this.constructComparableBarchartData();
  }

  selectedcompetitor: any;
  onChartClick(event: any) {
    // if (!event || event['blurElement']) return;
    if (!event) return;
    try {
      for (let i = 0; i < this.barchartData.length; i++) {
        if (this.barchartData[i] != event) {
          this.barchartData[i].selected = false;
        }
      }
      event.selected = true;
    } catch (e) {
      console.log(e);
    }

    if (this.comparableChart) {
      let competitor_value = this.barchartData.find(
        (obj: any) => obj.name == event.name
      )?.competitorObject;

      if (competitor_value) {
        if (competitor_value.meter_value == 'No') {
          competitor_value.meter_value = 0;
        } else if (competitor_value.meter_value == 'Yes') {
          competitor_value.meter_value = 1;
        } else if (typeof competitor_value.meter_value == 'string') {
          competitor_value.meter_value = parseFloat(
            competitor_value.meter_value.replace('%', '').replace('s', '')
          );
        }
      }

      if (this.correct_values?.[event?.name?.replace(/_embedding/gi, '')]) {
        this.meter_object = {
          ...this.correct_values?.[event?.name?.replace(/_embedding/gi, '')],
          competitor_value: competitor_value.meter_value,
          unit: competitor_value.unit,
        };
      } else {
        this.meter_object = undefined;
      }
    } else {
      let factor_object = this.barchartInputData.units?.[event.name];

      if (this.correct_values?.[event?.name?.replace(/_embedding/gi, '')]) {
        this.meter_object = {
          ...this.correct_values?.[event?.name?.replace(/_embedding/gi, '')],
          unit: factor_object?.unit,
        };
      } else {
        this.meter_object = undefined;
      }
    }

    if (!this.meter_object) {
      this.showMeterChart = false;
    } else {
      // if (event.name.includes('_sim') && this.meter_object.your_score < 1.1) {
      //   this.meter_object.your_score = this.meter_object.your_score * 100;
      // }
      this.meter_object.your_score =
        this.barchartInputData.yourScore?.[event.name];
      this.showMeterChart = true;
    }

    if (this.data_descriptionChart) {
      this.contructDescriptionChart(this.data_descriptionChart[event.name]);
    }

    this.selectedFactor = event;
    queueMicrotask(() =>
      this.barchartClicked.emit({ event: event, tab: 'tab2' })
    );
    this.selectedcompetitor = this.seoService.selectedKeyword?.value || '';
    this.selectProjectInsight = this.filterInsightDomain(
      this.barchartInputData.domain,
      event.name
    );
    if (this.selectedcompetitor) {
      this.competitorInsight = this.filterInsightDomain(
        this.selectedcompetitor.domain,
        event.name
      );

      if (!this.competitorInsight) {
        this.competitorInsight = {
          impact: 0,
          range: '0 - 10',
          value: 0,
        };
      }
    } else {
      this.competitorInsight = {
        impact: 0,
        range: '0 - 10',
        value: 0,
      };
    }
    this.factorName = event.name;

    if (
      this.selectProjectInsight?.['range'] != '' &&
      this.competitorInsight?.['range'] == ''
    ) {
      this.selectProjectInsight = this.filterInsightDomain(
        this.barchartInputData.domain,
        event.name,
        true
      );
      this.competitorInsight = this.filterInsightDomain(
        this.selectedcompetitor.domain,
        event.name,
        true
      );
    }
  }
  redirectToBilling() {
    if (this.fromSharablePage) {
      this.viewMoreClicked.emit();
      return;
    }

    this.router.navigate(['/seo/billing']);
  }
}
